import AttributesCoVTemperatureField from './AttributesCoVTemperatureField'

export default AttributesCoVTemperatureField
